import { IotaAuditResponse, IotaProjectPayloadsResult, SearchAuditRequest, AuditInput } from '../types/IotaAuditResult';
import appClient from '../../common/services/AppClient';
import { endpoints } from '../../../config';

export default class IotaAuditService {
    async searchAudit(request: SearchAuditRequest): Promise<IotaAuditResponse> {
        let { projectId, searchTerm, pageSize, page, dates } = request;

        const fieldsSearch = { dateFilter: null as {} | null };

        if (dates.length) {
            fieldsSearch.dateFilter = { dates: { first: dates[0], second: dates[1] } };
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = await appClient.post<{ result: IotaAuditResponse['lines']; pageInfo: { total: number } }>(
            `${endpoints.manageUrl}IotaRuntime/applications/audit/search`,
            {
                projectId: projectId,
                searchTerm: !searchTerm || searchTerm.length === 0 ? null : searchTerm,
                pageSize,
                page: page || 0,
                fieldsSearch: fieldsSearch || null
            }
        );

        if (result.isErr()) {
            throw result.error;
        }
        if (!result.value.result) {
            return new IotaAuditResponse();
        }

        var response = new IotaAuditResponse();
        response.total = result.value.pageInfo.total;
        response.lines = result.value.result;
        return response;
    }

    async getIotaProjectPayloads(sessionId: string, packageName: string): Promise<AuditInput[]> {
        const query = packageName ? `?packageName=${encodeURIComponent(packageName)}` : '';
        const result = await appClient.get<IotaProjectPayloadsResult['getIotaProjectPayloads']>(
            `${endpoints.manageUrl}IotaRuntime/applications/audit/${sessionId}/payloads${query}`
        );

        return result.unwrapOr([]);
    }
}
